import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from './actionCreators';
import { WebAuthnStatus } from './actionCreators';
import { useNavigate } from 'react-router-dom';
import { useJspVariables, useAuth, useDebugRender } from '../hooks';
import { getLabelFromJspVariables } from '../common/JspUtil';
import { IceIcon, PageContainer, PageHeader, UserMenu } from '../components';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


const PageWebAuthnAuth = () => {
    useDebugRender('PageWebAuthnAuth');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { launcher, panelStyle } = useJspVariables();

    const { authenticatedUser, logout } = useAuth();
    const webAuthnAuth = useSelector(state => state.tfaReducer.tfaStatus.webAuthnAuth);
    const tfaError = useSelector(state => state.tfaReducer.tfaError);

    useEffect(() => {
        dispatch(actions.getWebAuthnAuthRequest(
            authenticatedUser.authenticatedApp,
            authenticatedUser.authenticatedUser
        ));
        return () => {
            dispatch({ type: actions.TFA_CLEAR_ERROR });
        };
    }, []);

    const handleLogout = () => {
        if (authenticatedUser) {
            logout(authenticatedUser.user);
        }
    };

    const handleNavigate = (route) => {
        navigate(route);
    };

    return (
        <PageContainer id="pageWebAuthnAuth" dataAutomationId="page_web_authn_auth">
            <Box sx={panelStyle}>
                <UserMenu
                    authenticatedUser={authenticatedUser}
                    onLogout={handleLogout}
                    onNavigate={handleNavigate}
                />
                <IceIcon launcher={launcher} />
                <PageHeader dataAutomationId="webauthn_auth_header">{getLabelFromJspVariables('title_passkey_authentication')}</PageHeader>
                {tfaError && <Alert id="pageWebAuthnAuthAlert" data-automation-id="page_web_authn_auth_alert" severity="error" sx={{ mb: 1 }}>{tfaError.message}</Alert>}
                {webAuthnAuth === WebAuthnStatus.SUCCESS &&
                    <Typography variant="body2">{getLabelFromJspVariables('status_logged_in')}</Typography>
                }
                {webAuthnAuth === WebAuthnStatus.PROCESSING &&
                    <Typography variant="body2">{getLabelFromJspVariables('note_follow_screen_login')}</Typography>
                }
                {webAuthnAuth === WebAuthnStatus.FAILED &&
                    <Typography variant="body2">{getLabelFromJspVariables('err_passkey_login_failed')}</Typography>
                }
            </Box>
        </PageContainer>
    );
};

export default PageWebAuthnAuth;
